<script setup lang="ts">
import LeIconButton from "@dsk/components/IconButton/LeIconButton.vue";
import LeCross from "@dsk/icons/LeCross.vue";
import { computed } from "vue";
import type { VueI18n } from "vue-i18n";

const props = defineProps<{
  i18n: VueI18n;
  type: "changed-language-pair" | "changed-direction" | "changed-dictionary";
}>();

const emit = defineEmits<{
  (event: "closeToast"): void;
}>();

const message = computed<string>(() => {
  if (props.type === "changed-language-pair") {
    return props.i18n.t("le-search-changed-language-selector-toast.changed-language-pair-message");
  }

  if (props.type === "changed-dictionary") {
    return props.i18n.t("le-search-changed-language-selector-toast.changed-dictionary-message");
  }

  return props.i18n.t("le-search-changed-language-selector-toast.changed-direction-message");
});
</script>

<template>
  <div class="le-search-changed-language-selector-toast">
    <span>{{ message }}</span>

    <LeIconButton
      :aria-label="props.i18n.t('le-search-changed-language-selector-toast.close')"
      color="accent"
      @click="emit('closeToast')"
    >
      <LeCross aria-hidden="true" />
    </LeIconButton>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all.less";

.le-search-changed-language-selector-toast {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 15px;
  align-items: center;
}
</style>
